import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MonthlyTrend from './report/monthly-trend.component';
import BreakdownUsageTrend from './report/breakdown-usage.component';
import DATEPICKER_OR from "../../../common/custom-form/custom-date-picker.component";
import { inventoryUsageSpendActions } from "../../../../store/external/inventory/usagespend.reducer";
import Moment from 'moment';
import CustomExportButton from "../../../common/custom-form/custom-export-button.component";
import Translation from '../../../common/translation/translation.component';
import { Loading } from "../../../common/loading";
import { inventoryCircuitInvoiceActions } from "../../../../store/external/inventory/invoice/invoice.reducer";
class UsageSpend extends Component {
constructor(props) {
    super(props);  
    this.imageRef = {
        monthlyTrendRef: React.createRef(),
        breakdownUsageTrendRef: React.createRef(),
    };
    this.state = { 
        loading: true,       
        ledger: [
            { name: 'TotalNetAmount', label: 'Net Amount', color: '#ff861c' },
            { name: 'TotalGrossAmount', label: 'Gross Amount', color: '#0000ff' },
        ],
        dateFormat: "MMMM yyyy", 
        };
    }
    componentDidMount() {
        this.props.getInventoryUsageSpend(this.props.circuitId, this.props.financeAccountId);
        this.props.getInventoryCircuitInvoice(this.props.circuitId, this.props.financeAccountId);
    }

    SelectDatePicker(date) {
        this.setState({
            startDate: date
        });
        this.props.getInventoryUsageSpend(this.props.circuitId, this.props.financeAccountId, date);
    }

    PrintData(value) {
        this.setState({printData:value})
    }
  
    render() {
        const { getInventoryUsageSpend, inventoryUsageSpend,inventoryCircuitInvoice } = this.props;     
        const extractedInvoiceDate = inventoryCircuitInvoice.inventoryCircuitInvoiceItems.Data.Items.map(item => {
            const date = new Date(item.InvoiceDate);
            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            return { InvoiceMonth: month, InvoiceYear: year };
        });

        return (
        <>
            {
                inventoryUsageSpend.isInventoryUsageSpendLoaded ? 
            < div className = "usage-spend-layout-container date-picker-main-container" >
                <div className="component-form-filter">
                    <DATEPICKER_OR
                        label={<Translation translationKey="select_date" />}
                        startDate={this.state.startDate}
                        selectedDate={(date) => this.SelectDatePicker(date)}
                        isDisable={false}
                        dateFormat={this.state.dateFormat}
                        placeholder={Moment(new Date()).local().format('MMMM yyyy')}
                        renderKey={this.state.renderKey} 
                    />
                    <div className="usage-spend-export-container">
                    <CustomExportButton    
                        imageRef={this.imageRef}
                        circuitId={this.props.circuitId} 
                        circuitCode={this.props.circuitCode}
                        printData={this.PrintData.bind(this)} 
                        renderKey={this.state.renderKey}   
                        isReadOnly={this.props.isReadOnly}
                        isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                        isReadAndWrite={this.props.isReadAndWrite}
                           
                    />
                    </div>
                </div>
                <div id="chart-container" className="inventory-cards">
                <MonthlyTrend
                    dateCurrentMonth={this.props.inventoryUsageSpend.inventoryUsageSpendItems.summaryUsageSpendBreakdown.currentMonthUsageSpend}
                    dataSixMonths={this.props.inventoryUsageSpend.inventoryUsageSpendItems.summaryUsageSpendBreakdown.sixMonthsUsageSpend}
                    invoiceMonth={extractedInvoiceDate}
                    ledger={this.state.ledger}                     
                    setRef={ref => {
                        this.imageRef.monthlyTrendRef = ref;
                        if (this.monthlyTrendRef && this.breakdownUsageTrendRef) {
                            this.setState({ loading: false });
                        }
                    }}
                    selectedMonth={this.state.startDate}
                />                  
                <BreakdownUsageTrend
                    dateCurrentMonth={this.props.inventoryUsageSpend.inventoryUsageSpendItems.summaryUsageSpendBreakdown.currentMonthUsageSpend}
                    data={this.props.inventoryUsageSpend.inventoryUsageSpendItems.summaryUsageSpendBreakdown.currentMonthBreakdown} 
                    printData={this.state.printData}
                    resetData={this.PrintData.bind(this)}                   
                    setRef={ref => {
                        this.imageRef.breakdownUsageTrendRef = ref;
                        if (this.breakdownUsageTrendRef && this.breakdownUsageTrendRef) {
                            this.setState({ loading: false });
                        }
                    }}
                />               
                </div>
                    </div > : <Loading />
                }
            </>
    );
  }
}

export default connect(
    state => {
        const { inventoryUsageSpend, inventoryCircuitInvoice } = state;

        return {
            inventoryCircuitInvoice,
            inventoryUsageSpend
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryUsageSpendActions, inventoryCircuitInvoiceActions),
        dispatch
    )
)(UsageSpend);
